/**
 * This is the memword controller.
 * @memberOf memword Module
 * @namespace memword Controller
 */

/**
 * @name memwordController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf memword Module.memword Controller
 * @ngInject
 */
function memwordController($scope, $translate, coreService, $log) {
  // Assign this controller as the view-model.
  // It will be accessible as 'accountController' within the HTML template.
  var vm = this;

  // Register the view model's properties.
  vm.validateForm = validateForm;
  vm.submitted = false;

  vm.messages = [];

  vm.hideReminder = true;

  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {

    // Read Identity Server's data model
    var model = coreService.getIdentityModel();

    // Display error returned by Identity Server
    if (model.errorMessage) {
      //$log.error(model.errorMessage);
      vm.messages.push(model.errorMessage);
    }

    // Change display language
    if (model.custom && model.custom.ui_locales) {
      $translate.use(model.custom.ui_locales);
    }

    $scope.model = model;
  }

  // Validate the login account form.
  function validateForm(e) {
    // Update the form.
    vm.messages = [];
    vm.submitted = true;
    $scope.memwordForm.$dirty = true;
    $scope.memwordForm.$pristine = false;

    if ($scope.memwordForm.$invalid) {
      // Do not submit
      e.preventDefault();
    }
  }
}

export default memwordController;



// WEBPACK FOOTER //
// ./src/login/memword/memword.controller.js